"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
var models_1 = require("../models");
var JobRequisitionLocationDataProvider_1 = require("../shared/JobRequisitionLocationDataProvider");
var SearchFilterMapper_1 = require("./SearchFilterMapper");
var CareerSiteUrlProvider_1 = require("../shared/CareerSiteUrlProvider");
var JobRequisitionPostedDateGetter_1 = require("../shared/JobRequisitionPostedDateGetter");
var AwsApiServices = (function () {
    function AwsApiServices() {
        this.serviceBase = csod.context.serviceBase;
        this.baseUrl = this.serviceBase + "services/x/career-site";
        this.userId = csod.context.user;
        this.corp = csod.context.corp;
        this.locationDataProvider = new JobRequisitionLocationDataProvider_1.JobRequisitionLocationDataProvider();
        this.searchFilterMapper = new SearchFilterMapper_1.SearchFilterMapper();
        this.jobRequisitionPostedDateGetter = new JobRequisitionPostedDateGetter_1.JobRequisitionPostedDateGetter();
    }
    AwsApiServices.prototype.getNewResults = function (searchData) {
        var _this = this;
        var careerSiteUrlProvider = new CareerSiteUrlProvider_1.CareerSiteUrlProvider(csod.context.applicationBase, csod.context.corp, csodPlayerRouteInfo.cid, csod.context.cultureName);
        var isBrowserRouter = csod.viewModel.routerType === 'Browser';
        var url = csod.context.endpoints.cloud + "rec-job-search/external/jobs";
        var searchResults = {
            results: new Array(),
            totalSearchResults: 0,
            filters: new Array(),
            customFieldFilters: new Array()
        };
        return csod.service.post(url, searchData).then(function (response) {
            searchResults.results = response.data.requisitions.map(function (r) {
                return {
                    id: r.requisitionId,
                    title: r.displayJobTitle,
                    postingDateLabel: _this.jobRequisitionPostedDateGetter.getJobRequisitionPostedDate(r, csod.viewModel.isCareerSiteDisplayPostingEndDateEnabled.toLocaleLowerCase() === "true"),
                    location: _this.locationDataProvider.getLocationDisplayTitleForSearch(r.locations),
                    startDate: r.postingEffectiveDate,
                    endDate: r.postingExpirationDate,
                    jobDetailRelativeURL: isBrowserRouter ?
                        careerSiteUrlProvider.getRoutePrefix() + "/requisition/" + r.requisitionId + csod.viewModel.nonCustomFieldParams :
                        "/requisition/" + r.requisitionId
                };
            });
            if (searchData.placeID === '') {
                var targetGroupMap_1 = new Map();
                if (response.data.filters) {
                    response.data.filters.forEach(function (target) {
                        targetGroupMap_1.set(target.filterType, target);
                    });
                }
                if (csod.viewModel.ouLocations) {
                    csod.viewModel.ouLocations.forEach(function (source) {
                        var targetGroup = targetGroupMap_1.get(source.filterType);
                        if (!targetGroup) {
                            targetGroup = {
                                filterType: source.filterType,
                                doLocalize: source.filterType === "Country",
                                items: source.items
                            };
                            response.data.filters.push(targetGroup);
                        }
                        else {
                            if (targetGroup.items) {
                                var targetKeys = new Set(targetGroup.items.map(function (targetItem) { return targetItem.key.toLowerCase(); }));
                                if (source.items) {
                                    source.items.forEach(function (sourceItem) {
                                        if (!targetKeys.has(sourceItem.key.toLowerCase())) {
                                            targetGroup.items.push(sourceItem);
                                        }
                                    });
                                }
                            }
                            else {
                                targetGroup.items = source.items;
                            }
                        }
                    });
                }
            }
            _this.cleanUpFilterTypes(response.data.filters);
            searchResults.filters = _this.searchFilterMapper.getFilters(response.data.filters, csod.viewModel.isExternalCareerSiteDisplayKilometerFilterEnabled.toLocaleLowerCase() === "true");
            searchResults.totalSearchResults = response.data.totalCount;
            searchResults.customFieldFilters = _this.searchFilterMapper.getCustomFieldFilters(response.data.customFieldFilters);
            return searchResults;
        }).catch(function (error) {
            console.log(error);
            return searchResults;
        });
    };
    AwsApiServices.prototype.getKeywordPredictiveSearchResults = function (searchRequest) {
        var newRequest = {
            cultureId: searchRequest.cultureId,
            searchText: searchRequest.searchText,
            careerSitePageId: searchRequest.careerSiteId
        };
        var url = csod.context.endpoints.cloud + "rec-job-search/external/suggestions";
        return csod.service.post(url, newRequest)
            .catch(function (error) {
            console.log(error);
            return {
                data: {
                    suggestions: []
                }
            };
        });
    };
    AwsApiServices.prototype.cleanUpFilterTypes = function (filters) {
        filters.forEach(function (element) {
            switch (element.filterType.toString()) {
                case "Country":
                    element.filterType = models_1.FilterType.Country;
                    break;
                case "State":
                    element.filterType = models_1.FilterType.State;
                    break;
                case "City":
                    element.filterType = models_1.FilterType.City;
                    break;
                case "Distance":
                    element.filterType = models_1.FilterType.Distance;
                    break;
                case "DatePosted":
                    element.filterType = models_1.FilterType.DatePosted;
                    break;
                default: element.filterType = 'def';
            }
        });
    };
    return AwsApiServices;
}());
exports.AwsApiServices = AwsApiServices;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/f257358f111b2299/src/api/awsIndex.ts
// module id = 808
// module chunks = 0